<template>
  <div class="details-container">
    <!-- TITLE -->
    <div
      class="m-2"
      style="max-width:400px;"
    >
      <div class="table-sub-class text-sm">
        {{ $t('title') | capitalize }}
      </div>
      <div class="medium-bold">
        {{ title }}
      </div>
      <div
        v-for="metadata in getMetadata(extras,'title')"
        :key="metadata"
        class="table-sub-class text-sm"
      >
        {{ metadata }}
      </div>
    </div>
    <!-- ARTIST -->
    <div class="m-2">
      <div class="table-sub-class text-sm">
        {{ $t('artist') | capitalize }}
      </div>
      <div class="medium-bold">
        {{ artist }}
      </div>
      <div
        v-for="metadata in getMetadata(extras,'artist')"
        :key="metadata"
        class="table-sub-class text-sm"
      >
        {{ metadata }}
      </div>
    </div>
    <!-- ISRC -->
    <div class="m-2 ml-2">
      <div class="table-sub-class text-sm">
        {{ 'isrc' | upper }}
      </div>
      <div class="medium-bold">
        {{ isrc | upper }}
      </div>
    </div>
    <!-- LANG OF PERF -->
    <div class="m-2">
      <div class="table-sub-class text-sm">
        {{ $t('lang_of_perf') | capitalize }}
      </div>
      <div
        v-for="metadata in getMetadata(extras,'lang_of_perf')"
        :key="metadata"
        class="medium-bold"
      >
        {{ metadata }}
      </div>
    </div>
    <!-- DURATION -->
    <div class="m-2">
      <div class="table-sub-class text-sm">
        {{ $t('duration') | capitalize }}
      </div>
      <div class="medium-bold">
        {{ duration|normalizeSeconds }}
      </div>
    </div>
    <!-- YEAR -->
    <div class="m-2">
      <div class="table-sub-class text-sm">
        {{ $t('year') | capitalize }}
      </div>
      <div class="medium-bold">
        {{ year }}
      </div>
    </div>
    <!-- Type-->
    <div class="m-2">
      <div class="table-sub-class text-sm">
        {{ $t('type') | capitalize }}
      </div>
      <div class="medium-bold">
        {{ type }}
      </div>
    </div>
    <!-- COUNTRY -->
    <div class="m-2">
      <div class="table-sub-class text-sm">
        {{ $t('fixation_country') | capitalize }}
      </div>

      <div class="medium-bold">
        {{ fixationCountry|get('name') }}
      </div>
    </div>
    <!-- RELEASE NAMES -->
    <div class="m-2">
      <div class="table-sub-class text-sm">
        {{ $t('releaseNames') | capitalize }}
      </div>
      <ReleaseNames
        class-names="medium-bold"
        :releases="getMetadata(extras,'release')"
      />
    </div>
    <div class="m-2">
      <div class="table-sub-class text-sm" id="genres">
        {{ $t('genres') | capitalize }}
      </div>
      <ListTablePopover
        class-names="medium-bold"
        :columns="genreColumns"
        :items="genres"
      />
    </div>
    <!-- ELIGIBLE -->
    <div class="m-2">
      <div class="table-sub-class">
        Is Eligible
      </div>
      <toggle-button
        :sync="true"
        :value="eligible"
        color="#2ec775"
        @change="$emit('toggleEligible')"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.details-container {
  padding-bottom: 24px;
  padding-right: 24px;
  background-color: #f1f1f1;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
}
</style>

<script>
import { mapGetters } from "vuex"

export default {
  name: "RecordingDetails",
  computed: {
    ...mapGetters("soundsys", ["srTypes"])
  },
  data () {
    return {
      genreColumns: ["name"],
    }
  },
  methods: {
    getMetadata (extras, tag) {
      return this.extras.reduce((current, next) => {
        if (next.tag === tag) {
          current.push(next.value)
        }
        return current
      }, [])
    },
  },
  props: {
    title: { type: String, default: "-" },
    artist: { type: String, default: "-" },
    eligible: { type: Boolean },
    extras: { type: Array, default: () => [] },
    genres: { type: Array, default: () => [] },
    duration: { default: "-" },
    year: {},
    type: { type: String },
    isrc: { type: String, default: "-" },
    fixationCountry: {}
  }
}
</script>

